import { Component, OnInit, OnDestroy, AfterViewChecked } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { CURRENCY_ITEM, INGAME_ITEMS } from 'app/common/components/balances-item/balances-item-data';
import { eCurrencyItems, eIngameItems, IBalanceItem, ICurrencyItem, IIngameItem } from 'app/common/components/balances-item/balances-item-interface';
import { getCookieValue } from 'app/common/utils/cookie.util';
import { AuthService } from 'app/services/auth/auth.service';
import { StakingRewardsService } from 'app/services/contract/contracts-services/staking-rewards.service';
import { TokenService } from 'app/services/contract/contracts-services/token.service';
import { IboxBalance } from 'app/services/items/items.interface';
import { ItemsService } from 'app/services/items/items.service';
import { KSideMenuService } from 'app/services/k-side-menu/k-side-menu.service';
import { NavigationService } from 'app/services/navigation/navigation.service';
import { INavigationItem } from 'app/services/navigation/navigation.types';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { IUserData } from 'app/services/user/user.interface';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { Subscription, first } from 'rxjs';


@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.scss']
})
export class UserLayoutComponent implements OnInit, OnDestroy, AfterViewChecked {

  private navigationSubscription: Subscription;
  private menuCollapsedSubscription: Subscription;
  private userDataSubscription: Subscription;

  userData: IUserData;
  userNavigation: INavigationItem[];
  balanceItemList: Array<eIngameItems | eCurrencyItems> = BALANCE_ITEM_LIST();//It is the order list of all items
  balanceItems: IBalanceItem[] = []; //used to merge and display both items and currency
  ingameItems: Map<eIngameItems, IIngameItem> = INGAME_ITEMS();
  currencyItems: Map<eCurrencyItems, ICurrencyItem> = CURRENCY_ITEM();
  isMenuCollapsed: boolean;
  showQuickPurchase: boolean = false;
  ingameItemFocus: Map<eIngameItems, boolean> = new Map<eIngameItems, boolean>();
  quickPurchaseItem: IIngameItem;
  cookieCheckInterval: NodeJS.Timeout;

  constructor(
    private navigationService: NavigationService,
    private toastService: ToastService,
    private kSideMenuService: KSideMenuService,
    private userService: UserService,
    private authService: AuthService,
    private router: Router,
    private itemService: ItemsService,
    private tokenService: TokenService,
    private web3Service: Web3Service,
    private stakingRewardsService: StakingRewardsService
  ) {
    this.navigationService.get();
    this.userDataSubscription = this.userService.userInfo$.subscribe(u => {
      this.userData = u;
    });
  }

  ngOnInit(): void {
    this.navigationSubscription = this.navigationService.navigation$.subscribe(nav => {
      this.userNavigation = nav.user;
    })
    this.getIbalanceItems();
    this.menuCollapsedSubscription = this.kSideMenuService.isCollapsed$.subscribe(v => {
      this.isMenuCollapsed = v;
    })
    //initialize array for item focus
    this.ingameItems.forEach((i, key) => {
      this.ingameItemFocus.set(key, false);
    })
    this.userService.getReferralCode(this.userData.recordedWallet).pipe(first()).subscribe();
    this.checkCookieSession();
  }


  ngOnDestroy(): void {
    this.navigationSubscription.unsubscribe();
    this.menuCollapsedSubscription.unsubscribe();
    this.userDataSubscription.unsubscribe();
  }

  onItemClick(item: INavigationItem) {
    console.log('navigation Item clicked', item)
  }

  logOut() {
    this.authService.signOut();
  }

  ngAfterViewChecked(): void {
    //move quick purchase container according to balance-item-container
    let quickPurchaseEl = document.getElementById('quick-purchase-container') as HTMLElement;
    if (quickPurchaseEl) {
      let el = document.getElementById('balance-item-container');
      let l = el.getBoundingClientRect().left;
      quickPurchaseEl.style.left = l + 'px';
    }
  }

  copyToClipboard(text: string) {

    navigator.clipboard.writeText(text).then(e => {
      this.toastService.add(
        {
          severity: 'info',
          summary: 'shared.copied',
          detail: 'toastMessage.walletCopied',
        });
    }).catch(e => console.error(e));
  }

  getIbalanceItems() {
    //SET STRUCTURE
    this.itemService.checkBoxBalance(this.userData.recordedWallet).subscribe();
    this.balanceItems = this.balanceItemList.map(i => {
      return {
        ...this.ingameItems.get(eIngameItems[i]),
        ...this.currencyItems.get(eCurrencyItems[i]),
        key: i
      }
    });
    //UPDATE BALANCE OF ITEMS
    this.itemService.boxBalance$.subscribe((items: IboxBalance[]) => {
      items.forEach(i => this.balanceItems.filter(bi => bi.key == i.type)[0].balance = i.count);
    });
    //UPDATE POINTS
    this.userService.userRefCode$.subscribe(item => {
      this.balanceItems.filter(bi => bi.key == eCurrencyItems.POINTS)[0].balance = item.loyalty.programs.kryptomon_loyalty_prod.ledger.currentBalance;
    })
    //UPDATE KMON BALANCE
    this.tokenService.KMONbalance(this.userData.recordedWallet).pipe(first()).subscribe();
    this.tokenService.KMONBalance$.subscribe(value => {
      this.balanceItems.filter(bi => bi.key == eCurrencyItems.KMON)[0].balance = value.float;
    });
    //UPDATE BNB BALANCE
    this.web3Service.updateBalanceBnB(this.userData.recordedWallet);
    this.web3Service.balanceBnB$.subscribe(value => {
      this.balanceItems.filter(bi => bi.key == eCurrencyItems.BNB)[0].balance = value.float;
    });
    //UPDATE POINTS
    this.stakingRewardsService.earned(this.userData.recordedWallet).pipe(first()).subscribe();
    this.stakingRewardsService.pointsBalance$.subscribe(value => {
      this.balanceItems.filter(bi => bi.key == eCurrencyItems.POINTS)[0].balance = value.float;
    })
  }

  clearAllBalanceItemFocus() {
    [...this.ingameItemFocus.keys()].forEach((key) => {
      this.ingameItemFocus.set(key, false);
    });
  }
  goToPlay() {
    this.router.navigate(['play']);
  }

  onBalanceItemClick(id: eIngameItems | eCurrencyItems) {
    // console.log(id);
    if (Object.keys(eIngameItems).includes(id)) {
      this.clearAllBalanceItemFocus();
      let nid = id as eIngameItems;
      this.showQuickPurchase = true;
      this.ingameItemFocus.set(nid, true);
      // this.quickPurchaseItem = this.ingameItems.get(nid);
      this.quickPurchaseItem = this.balanceItems.filter(i => i.type === id)[0];
    } else {
      switch (id) {
        case eCurrencyItems.BNB:
          this.router.navigate(['wallet']);
          break;
        case eCurrencyItems.KMON:
          this.router.navigate(['wallet']);
          break;
        case eCurrencyItems.POINTS:
          this.router.navigate(['referral']);
          break;
        case eCurrencyItems.CANDIES:
          this.router.navigate(['staking']);
          break;
        default:
          break;
      }
    }
  }

  checkCookieSession() {
    //its not necessary to clear cookieCheckInterval, because application will refresh
    this.cookieCheckInterval = setInterval(() => {
      if (!getCookieValue('recordedWallet')) this.toastService.sessionExpired();
    }, 60000);
  }

  onSessionExpired() {
    location.reload();
  }

  closeMenu(): void {
    this.kSideMenuService.setCollapsed(true);
  }

  clickOutsideNavbar(event: boolean) {
    this.showQuickPurchase = event ? false : this.showQuickPurchase;
    if (event) this.clearAllBalanceItemFocus();
  }


}

//ORDER for Balance Item list
const BALANCE_ITEM_LIST = (): Array<eIngameItems | eCurrencyItems> => {
  return [
    eIngameItems.UNFREEZE_POTION,
    eIngameItems.DIAMOND_STORY_CHEST,
    eIngameItems.LOOTBOX_PREMIUM,
    eIngameItems.LOOTBOX_MEDIUM,
    eIngameItems.LOOTBOX_BASIC,
    eCurrencyItems.KMON,
    eCurrencyItems.BNB,
    eCurrencyItems.POINTS,
    eCurrencyItems.CANDIES
  ]
}